import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const StopWatchIcon = ({ color = '#FFFFFF', size = 48, ...props }) => (
  <svg
    width={size}
    viewBox="0 0 22 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill={color} fillRule="nonzero">
      <path d="M10.267 0a.964.964 0 0 0-.123.012H7.71a.858.858 0 1 0 0 1.713h1.714v1.758C4.156 3.92 0 8.34 0 13.719 0 19.387 4.613 24 10.28 24c5.668 0 10.281-4.613 10.281-10.28 0-2.527-.92-4.84-2.438-6.632l1.243-1.243.607.606V6.45a.856.856 0 0 0 1.223.012.856.856 0 0 0-.01-1.223l-1.101-1.1h-.001a.876.876 0 0 0-.212-.214L18.76 2.813v.001a.855.855 0 1 0-1.211 1.211l.606.608-1.243 1.243a10.23 10.23 0 0 0-5.775-2.394V1.724h1.714v.001a.86.86 0 0 0 .868-.856.859.859 0 0 0-.868-.857h-2.439A.827.827 0 0 0 10.267 0Zm-.087 5.157a.962.962 0 0 0 .208 0 8.53 8.53 0 0 1 5.83 2.386h-.001a.873.873 0 0 0 .237.236 8.533 8.533 0 0 1 2.393 5.94 8.554 8.554 0 0 1-8.567 8.567 8.554 8.554 0 0 1-8.568-8.567 8.55 8.55 0 0 1 8.467-8.562Z" />
      <path d="M10.267 8.567a.857.857 0 0 0-.843.869v2.797a1.722 1.722 0 0 0-.356 2.703 1.71 1.71 0 0 0 2.424 0 1.722 1.722 0 0 0-.354-2.704V9.436a.856.856 0 0 0-.871-.869Z" />
    </g>
  </svg>
);

StopWatchIcon.propTypes = propTypes;

export default StopWatchIcon;
